import PropTypes from 'prop-types';

import { checkRole } from '../../helpers';

const RequireRole = ({
  child,
  userRoles,
  requiredRole,
}) => (checkRole(userRoles, requiredRole) ? child : null);

RequireRole.propTypes = {
  child: PropTypes.element.isRequired,
  userRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  requiredRole: PropTypes.string.isRequired,
};

export default RequireRole;



// WEBPACK FOOTER //
// ./src/components/RequireRole/RequireRole.jsx